export const CURRENT_TASK = '/currtask';
export const ALL_TASKS = '/alltasks';
export const TASK_WITH_ID = '/tasks/:userId/:taskId/:pieceId'
export const LOG_IN = '/login';
export const LOG_OUT = '/logout';


// WEBPACK FOOTER //
// ../shared-components/src/shared/routes.js